import { Modules } from 'sigma-mappings';

const modulesDictionary = vm => ([
  {
    id: Modules.CHROMATOGRAPHY,
    name: vm.$t('enums.engineering.chromatography.name'),
  },
  {
    id: Modules.PHYSICAL_CHEMICAL,
    name: vm.$t('enums.engineering.physical-chemical.name'),
  },
]);

export default modulesDictionary;
